<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination :max-items="maxItem" search :data="_loginLogs">

          <template slot="header">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">{{ $t("sections.system.dataForm.limit", {maxItem, total: _loginLogs.length}) }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="maxItem = value" :key="i" v-for="(value, i) in maxItemsOption">
                    <span>{{ value }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
          <template slot="thead">
            <vs-th sort-key="email">{{ $t("sections.system.dataForm.account.email") }}</vs-th>
            <vs-th sort-key="createdAt">{{ $t("sections.system.dataForm.createdAt") }}</vs-th>
            <vs-th sort-key="type">{{ $t("sections.system.dataForm.type") }}</vs-th>
            <vs-th sort-key="status">{{ $t("sections.system.dataForm.status") }}</vs-th>
            <vs-th sort-key="token" class="w-4/12">{{ $t("sections.system.dataForm.token") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="setEmail(tr.account)">
                {{ setEmail(tr.account) }}
              </vs-td>
              <vs-td :data="setMoment(tr.createdAt)">
                {{ setMoment(tr.createdAt) }}
              </vs-td>
              <vs-td :data="tr.type">
                {{ tr.type }}
              </vs-td>
              <vs-td :data="tr.status">
                <vs-chip :color="getStatusColor(tr.status)">{{ tr.status }}</vs-chip>
              </vs-td>
              <vs-td :data="tr.token" class="wrapword">
                <p>{{  tr.token  }}</p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const {mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  data () {
    return {
      maxItem: 10,
      maxItemsOption: [5, 10, 20, 100],
    }
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  async created () {
    await this.getLoginLogs()
    this.pms ('SystemLoginLog', 'visible', 'r')
  },
  computed: {
    ...mapSystemState(['loginLogs', 'status']),
    _loginLogs() {
      return this.loginLogs
    },
  },
  methods: {
    ...mapSystemActions(['getLoginLogs']),
    setMoment(datetime){
      return moment(datetime).format()
    },
    setEmail(account){
      return ( account ? account.email: '')
    },
    getStatusColor (status) {
      if (status === 'Passed')   return 'success'
      else return 'danger'
    },
  }
}
</script>
<style scoped>
</style>
